import WhatApp from "./WhatApp";
export default WhatApp;